import * as React from 'react'

import { SettingsContext } from '../context/settings-context'
import type { SettingsContextValue } from '../context/settings-context'

export function useSettings(): SettingsContextValue {
  const ctx = React.useContext(SettingsContext)

  if (!ctx) {
    throw new Error('useSettings must be used within a SettingsProvider')
  }

  return ctx
}
